import { useRef, useEffect, useState } from 'react';
import classNames from 'classnames';
import styles from './ShareSNSButton.module.scss';
import { TwitterShareButton } from 'react-share';
import Tippy from '@tippyjs/react';
import { useRouter } from 'next/router';
import { VFC } from 'react';
import useOnClickOutside from '@/hooks/useOnClickOutside';
import ShareIcon from '@/icons/share-icon.svg';
import TwitterIcon from '@/icons/twitter.svg';
import CopyLinkIcon from '@/icons/copy-link.svg';

type Props = {
  userTwitter?: string;
  placeCenterWhenMobile?: boolean;
};

const ShareSNSButton: VFC<Props> = ({ userTwitter, placeCenterWhenMobile }) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [hasCopied, setHasCopied] = useState(false);
  const [activeTab, setActiveTab] = useState('Artwork');

  // get the current page URL
  const { asPath } = useRouter();
  const origin =
    typeof window !== 'undefined' && window.location.origin
      ? window.location.origin
      : '';
  let currentURL = `${origin}${asPath}`;
  useEffect(() => {
    currentURL = `${origin}${asPath}`;
    if (asPath.includes('#created')) {
      setActiveTab('Created');
    } else if (asPath.includes('#collected')) {
      setActiveTab('Collected');
    } else if (asPath.includes('#limited-collection')) {
      setActiveTab('Limited Collection');
    }
  }, [currentURL]);

  const handleShareButtonClick = () => {
    setShowDropdown(!showDropdown);
  };

  const copyPageLink = async () => {
    await navigator.clipboard.writeText(currentURL);
    setHasCopied(true);
  };

  let tweetText = `Check out this collection on ANIFTY\n@anifty_jp `;
  if (userTwitter) {
    tweetText += `@${userTwitter}`;
  }

  // Handle clicks outside of dropdown
  const wrapperRef = useRef();
  useOnClickOutside(wrapperRef, () => setShowDropdown(false));

  return (
    <div className={styles.shareContainer} ref={wrapperRef}>
      <button onClick={handleShareButtonClick} className={styles.dropdownBtn}>
        <ShareIcon />
      </button>
      {showDropdown && (
        <div
          className={classNames(styles.shareDropdown, {
            [styles.placeCenterWhenMobile]: placeCenterWhenMobile
          })}
        >
          <TwitterShareButton
            title={tweetText}
            url={currentURL}
            hashtags={['ANIFTY', 'nftart', 'animeNFT', 'nft']}
          >
            <TwitterIcon
              fill="#1DA1F2"
              display="block"
              width="35"
              height="35"
            />
            <span>Share on Twitter</span>
          </TwitterShareButton>
          <Tippy
            content={hasCopied ? 'Copied!' : `Copy Link`}
            placement="bottom"
            hideOnClick={false}
            onHide={() => setHasCopied(false)}
          >
            <button onClick={copyPageLink}>
              <CopyLinkIcon display="block" />
              <span>Copy {activeTab} Link</span>
            </button>
          </Tippy>
        </div>
      )}
    </div>
  );
};

export default ShareSNSButton;
